import { computed, observable, makeObservable } from 'mobx';

import { createModelSchema, primitive } from 'serializr';

export class TrackingLinkPolicy {
    email = '';
    enabled = false;
    mode = 'underway';
    overflowEnabled = false;
    /** phone masking through twilio */
    proxyEnabled = false;
    senderId = '';
    sms = '';
    subject = '';

    constructor() {
        makeObservable(this, {
            email: observable,
            enabled: observable,
            mode: observable,
            overflowEnabled: observable,
            proxyEnabled: observable,
            senderId: observable,
            sms: observable,
            smsSegments: computed,
            subject: observable,
        });
    }

    get smsSegments(): number {
        return Math.ceil(this.sms.length / 140);
    }
}

createModelSchema(TrackingLinkPolicy, {
    email: primitive(),
    enabled: primitive(),
    mode: primitive(),
    overflowEnabled: primitive(),
    proxyEnabled: primitive(),
    senderId: primitive(),
    sms: primitive(),
    subject: primitive()
});
